<template>
    <highcharts :options="chartOptions" ref="chart"></highcharts>
</template>

<script>
export default {
    props: ["data", "reverse", "label", "max", "color", "formatter"],
    data() {
        return {
            chartOptions: {
                chart: {
                    type: "bar",
                    height: 50,
                    backgroundColor: null,
                    style: {
                        fontFamily: "CeraPro",
                    },
                },
                title: {
                    text: null,
                },
                tooltip: {
                    enabled: false,
                },
                plotOptions: {
                    bar: {
                        stacking: "normal",
                    },
                },
                legend: {
                    enabled: false,
                },
                series: [
                    {
                        data: [this.data],
                        color: this.color,
                        name: "",
                        pointWidth: 40,
                        borderWidth: 0,
                    },
                ],
                xAxis: {
                    lineColor: "transparent",
                    categories: [this.label],
                    labels: {
                        style: {
                            color: "#fff",
                        },
                    },
                    tickColor: "transparent",
                    reversed: this.reverse,
                    title: {
                        text: null,
                    },
                    labels: {
                        enabled: false,
                    },
                },
                yAxis: {
                    gridLineColor: "transparent",
                    reversed: this.reverse,
                    max: this.max,
                    stackLabels: {
                        // reversed: this.reverse,
                        x: this.reverse ? -60 : 0,
                        enabled: true,
                        align: this.reverse ? "left" : "right",
                        textOutline: 0,
                        formatter: function () {
                            return Math.abs(this.total) > 999
                                ? "€" +
                                      Math.sign(this.total) *
                                          (Math.abs(this.total) / 1000).toFixed(
                                              1
                                          ) +
                                      "k"
                                : Math.sign(this.total) * Math.abs(this.total);
                        },
                        style: {
                            color: "#fff",
                            textOutline: 0,
                            fontSize: "14px",
                            fontWeight: "regular",
                        },
                    },
                    title: {
                        text: null,
                    },
                    labels: {
                        enabled: false,
                    },
                },
            },
        };
    },
    mounted() {},
    watch: {
        data: {
            handler: function () {
                this.chartOptions.xAxis.categories = [this.label];
                this.chartOptions.series[0].data = [this.data];
                this.chartOptions.series[0].color = this.color;
                this.chartOptions.yAxis.max = this.max;
                // console.log(this.label + ' max:' + this.max);
                // this.chartOptions.yAxis.stackLabels.align = this.reverse ? 'left': 'right';
                let offset_x = 0;
                if (this.data > 1000 && this.reverse) {
                    offset_x = -60;
                } else if (this.data > 0 && this.data < 100 && this.reverse) {
                    offset_x = -20;
                } else if (this.data == 0 && this.reverse) {
                    offset_x = -20;
                }
                this.chartOptions.yAxis.stackLabels.x = offset_x;
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        kFormatter(num) {
            return Math.abs(num) > 999
                ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1)
                : Math.sign(num) * Math.abs(num);
        },
    },
};
</script>
